module.exports = new __parcel__URL__("Charlie_Display-Regular.7f5225e3.woff2").toString();